<template>
  <li class="inbox-accordion card card-row py-2 flex-wrap transition">
      <a href="#" class="tab__link p-0 no-underline flex content-center items-center w-full" @click.prevent="active = !active">
        <slot name="header"> </slot>
          <span class="pl-3 leading-tight print:hidden" v-show="!active"><i aria-hidden="true" class="material-icons leading-tight text-base p-0">expand_more</i></span>
          <span class="pl-3 text-block text-red-800" v-show="active"><i aria-hidden="true" class="material-icons leading-tight text-base">cancel</i></span>
      </a>
        <div class="accordion-content" v-show="active">
          <slot name="content"> </slot>
        </div>
  </li>
</template>
}
<script>
export default {

  props: ['title', 'icon', 'description'],

  data () {
  return {
      active: false,
    }
  },
}
</script>
